const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @utils
const { formatText, FormattedText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');

// @constants
const {
    BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE,
    TYPE_FUNDS,
    BROKER_ADVANCED_SEARCH_SLIDER_MIN,
    BROKER_ADVANCED_SEARCH_SLIDER_MAX,
    BROKER_ADVANCED_SEARCH_CURRENCIES_SPLIT_STRING,
    OK_SLIDER_TYPE_RANGE,
    PERCENTAGE_SYMBOL,
} = require('constants/index');

// @components
const MorningStarCheckboxGroup = require('components/broker/morningStarCheckboxGroup/morningStarCheckboxGroup');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

// @localComponents
const RiskButtonsGroup = require('./commons/riskButtons');

class FundsFilters extends React.Component {
    constructor(props) {
        super(props);

        this.handlePromoterChange = this.handlePromoterChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.handleTraspassableFund = this.handleTraspassableFund.bind(this);
        this.handleMorningStar = this.handleMorningStar.bind(this);
        this.handleProfitabilitySlider = this.handleProfitabilitySlider.bind(this);
        this.handleRisk = this.handleRisk.bind(this);
        this.adaptSelectOptions = this.adaptSelectOptions.bind(this);
        this.adaptCurrenciesOptions = this.adaptCurrenciesOptions.bind(this);
        this.handleToggleAdditionalFilters = this.handleToggleAdditionalFilters.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);
        /* TODO this.handleGeoZoneChange = this.handleGeoZoneChange.bind(this);*/
    }

    adaptCurrenciesOptions(options) {
        options = options.toJS();
        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsF')},
            ...options.map(item => {
                return {value: item, label: item.split(BROKER_ADVANCED_SEARCH_CURRENCIES_SPLIT_STRING)[1]};
            })
        ];
    }

    adaptSelectOptions(options, categoryOptions = false) {
        options = options.toJS();
        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsF')},
            ...options.map(item => {
                return {value: item.id, label:  categoryOptions ? formatText(`broker-fundsOptions_${item.id}`): item.name};
            })
        ];
    }


    adaptSelectTraspassableFundsOptions(options) {
        options = options.toJS();
        return [
            {value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsM')},
            ...options.filter(item => item !== BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE).map(item => {
                return {value: item, label: toFirstUppercase(formatText(`common-${item}`))};
            })
        ];
    }

    additionalFilters(searchState) {
        /* TODO
        const activeGeoZone = searchState.getIn(['selectedValues', TYPE_FUNDS, 'geoZone']);
        const geoZonesOptions = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_FUNDS, 'geographicZones']));
        */
        const lowRiskIsActive = searchState.getIn(['selectedValues', TYPE_FUNDS, 'risk', 'low']);
        const mediumRiskIsActive = searchState.getIn(['selectedValues', TYPE_FUNDS, 'risk', 'medium']);
        const highRiskIsActive = searchState.getIn(['selectedValues', TYPE_FUNDS, 'risk', 'high']);

        const stars = searchState.getIn(['selectedValues', TYPE_FUNDS, 'stars']).reduce((prev, curr, currIndex) => {
            return [...prev, { stars: currIndex + 1, checked: curr ? true : false }];
        }, []);

        const profitRange = [
            searchState.getIn(['selectedValues', TYPE_FUNDS, 'minProfitabilityRange']),
            searchState.getIn(['selectedValues', TYPE_FUNDS, 'maxProfitabilityRange'])
        ];

        const traspassableFundValue = searchState.getIn(['selectedValues', TYPE_FUNDS,'traspassableFund']);
        const traspassableFundOptions = this.adaptSelectTraspassableFundsOptions(searchState.getIn(['filters', TYPE_FUNDS, 'traspassableFund']));

        return (
            <div className="broker-advanced-search-explore__rest-of-filters">
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__column-1">
                        <OKSelect
                            id="selBrokerTraspassableFund"
                            label="broker-advancedSearchTraspassableFundLabel"
                            options={traspassableFundOptions}
                            value={traspassableFundValue}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleTraspassableFund}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__column-2">
                        <label className="broker-advanced-search-explore__label">
                            <FormattedText value="broker-advancedSearchFundRisk" />
                        </label>
                        <RiskButtonsGroup
                            risks={[lowRiskIsActive, mediumRiskIsActive, highRiskIsActive]}
                            onHandleRiskChange={this.handleRisk}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__column-3">
                        <label className="broker-advanced-search-explore__label">
                            <FormattedText value="broker-advancedSearchRatingMorningstar"/>
                        </label>
                        <MorningStarCheckboxGroup
                            values={stars}
                            onChange={this.handleMorningStar}
                            />
                    </div>
                    <div className="broker-advanced-search-explore__column-4 broker-advanced-search-explore__column-4--slider-input">
                        <label className="broker-advanced-search-explore__label broker-advanced-search-explore__label--slider-input">
                            <FormattedText value="broker-advancedSearchProfitabilityRanking"/>
                        </label>
                        <FormattedText
                            value="broker-advancedSearchYTDLabel"
                            className="broker-advanced-search-explore__ytd-label"
                        />
                        <div className="broker-advanced-search-explore__ok-slider-wrapper">
                            <OKSliderInput
                                min={BROKER_ADVANCED_SEARCH_SLIDER_MIN}
                                max={BROKER_ADVANCED_SEARCH_SLIDER_MAX}
                                minLabel={BROKER_ADVANCED_SEARCH_SLIDER_MIN}
                                maxLabel={BROKER_ADVANCED_SEARCH_SLIDER_MAX}
                                defaultValue={profitRange}
                                type={OK_SLIDER_TYPE_RANGE}
                                onAfterChange={this.handleProfitabilitySlider}
                                unit={PERCENTAGE_SYMBOL}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleCategoryChange(category) {
        this.props.onHandleFieldChange('category', category.value);
    }

    handleCurrencyChange(currency) {
        this.props.onHandleFieldChange('currency', currency.value);
    }

    handleMorningStar(stars) {
        this.props.onHandleFieldChange('stars', stars);
    }

    handleNameInput(ev) {
        this.props.onHandleFieldChange('term', ev.target.value);
    }

    handleProfitabilitySlider(values) {
        this.props.onHandleFieldChange('profitability', values);
    }

    handlePromoterChange(promoter) {
        this.props.onHandleFieldChange('promoter', promoter.value);
    }

    handleRisk(riskType) {
        this.props.onHandleFieldChange('risk', riskType);
    }

    handleToggleAdditionalFilters() {
        this.props.onHandleToggleAdditionalFilters();
    }

    /** TODO
     * geozone
    handleGeoZoneChange(geoZone) {
        this.props.onHandleFieldChange('geoZone', geoZone.value);
    }
    */

    handleTraspassableFund(traspassable) {
        this.props.onHandleFieldChange('traspassableFund', traspassable.value);
    }

    primaryFilters(searchState, showAdditionalFilters) {
        const { embeddedSearch } = this.props;
        const promoters = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_FUNDS, 'promoters']));
        const customCategories = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_FUNDS, 'customCategories']), true);
        const currencies = this.adaptCurrenciesOptions(searchState.getIn(['filters', TYPE_FUNDS, 'currencies']));

        const activePromoter = searchState.getIn(['selectedValues', TYPE_FUNDS, 'promoter']);
        const activeCategory = searchState.getIn(['selectedValues', TYPE_FUNDS, 'category']);
        const activeCurrency = searchState.getIn(['selectedValues', TYPE_FUNDS, 'currency']);

        const nameInputValue = searchState.getIn(['selectedValues', TYPE_FUNDS, 'term']);
        const nameInputLabel = formatText('broker-advancedSearchNameIsinLabel');

        const expandLinkText = formatText('broker-advancedSearchExpandLink');
        const collapseLinkText = formatText('broker-advancedSearchCollapseLink');
        const additionalFiltersToggleButton = showAdditionalFilters ? collapseLinkText : expandLinkText;


        if (embeddedSearch) {
            return (
                <div>
                    <div>
                        <div className="broker-advanced-search-explore__two-third-box">
                            <label className="broker-advanced-search-explore__label">
                                {nameInputLabel}
                            </label>
                            <InputSafe
                                id="inpBrokerAdvancedSearchTerm"
                                value={nameInputValue}
                                onChange={this.handleNameInput}
                                type="text"
                            />
                        </div>

                        <div className="broker-advanced-search-explore__embedded-filters">
                            <div className="broker-advanced-search-explore__one-third-box">
                                <OKSelect
                                    id="selBrokerAdvancedSearchPromoter"
                                    label="broker-advancedSearchPromoterLabel"
                                    name="advanced-search-promoter"
                                    className="broker-advanced-search-explore__promoter-select"
                                    options={promoters}
                                    value={activePromoter}
                                    clearable={false}
                                    searchable={false}
                                    onChange={this.handlePromoterChange}
                                />
                            </div>
                            <div className="broker-advanced-search-explore__one-third-box">
                                <OKSelect
                                    id="selBrokerAdvancedSearchCategory"
                                    label="broker-advancedSearchCategoryLabel"
                                    name="advanced-search-category"
                                    className="broker-advanced-search-explore__category-select"
                                    options={customCategories}
                                    value={activeCategory}
                                    clearable={false}
                                    searchable={false}
                                    onChange={this.handleCategoryChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        
        return (
            <div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <label className="broker-advanced-search-explore__label">
                            {nameInputLabel}
                        </label>
                        <InputSafe
                            id="inpBrokerAdvancedSearchTerm"
                            value={nameInputValue}
                            onChange={this.handleNameInput}
                            type="text"
                        />
                    </div>
                </div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchPromoter"
                            label="broker-advancedSearchPromoterLabel"
                            name="advanced-search-promoter"
                            className="broker-advanced-search-explore__promoter-select"
                            options={promoters}
                            value={activePromoter}
                            clearable={false}
                            searchable={false}
                            onChange={this.handlePromoterChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchCategory"
                            label="broker-advancedSearchCategoryLabel"
                            name="advanced-search-category"
                            className="broker-advanced-search-explore__category-select"
                            options={customCategories}
                            value={activeCategory}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleCategoryChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-fifth-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchCurrency"
                            label="broker-advancedSearchCurrencyLabel"
                            name="advanced-search-currency"
                            className="broker-advanced-search-explore__currency-select"
                            options={currencies}
                            value={activeCurrency}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleCurrencyChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__toggle-button-box">
                        <div id="btnBrokerAdvancedSearchToggleFilters"
                            className="broker-advanced-search-explore__toggle-button"
                            onClick={this.handleToggleAdditionalFilters}
                        >
                            {additionalFiltersToggleButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildInputOnly(searchState) {
        const nameInputValue = searchState.getIn(['selectedValues', TYPE_FUNDS, 'term']);
        const nameInputLabel = formatText('broker-advancedSearchNameIsinLabel');
        return (
            <div>
                <label className="broker-advanced-search-explore__label">
                    {nameInputLabel}
                </label>
                <InputSafe
                    id="inpBrokerAdvancedSearchTerm"
                    value={nameInputValue}
                    onChange={this.handleNameInput}
                    type="text"
                />
            </div>
        )
    }

    render() {

        const {
            showAdditionalFilters,
            searchState,
            inputOnly
        } = this.props;

        const primaryFilters = this.primaryFilters(searchState, showAdditionalFilters);
        const additionalFilters = showAdditionalFilters ? this.additionalFilters(searchState) : undefined;
        const content = inputOnly ? this.buildInputOnly(searchState) : (
            <div className="broker-advanced-search-explore__type-filters">

                {primaryFilters}

                {additionalFilters}

            </div>
        )

        return (content);
    }
}

FundsFilters.propTypes = {
    showAdditionalFilters: PropTypes.bool,
    searchState: PropTypes.object.isRequired,
    onHandleFieldChange: PropTypes.func.isRequired,
    onHandleToggleAdditionalFilters: PropTypes.func.isRequired,
    embeddedSearch: PropTypes.bool,
    inputOnly: PropTypes.bool
}

module.exports = FundsFilters;

/** TODO
 * geographic zone block in additionalFilters once ready in api
 *
 <div className="broker-advanced-search-explore__one-third-box">
    <OKSelect
        id="selBrokerAdvancedSearchGeoZone"
        label="broker-advancedSearchGeoZoneLabel"
        name="advanced-search-geo-zone"
        className="broker-advanced-search-explore__geographic-zone-select"
        options={geoZonesOptions}
        value={activeGeoZone}
        clearable={false}
        searchable={false}
        onChange={this.handleGeoZoneChange}
    />
</div>
 */
